import { type Biome } from '@goodtime/shared';
import { KingdomMidEffects } from './KingdomMidEffects';
import { CoveMidEffects } from './CoveMidEffects';

export interface BiomeMidEffectsProps {
  biomeId: Biome['id'];
}

/**
 * L2 (mid-ground) idle effects dispatcher.
 *
 * <p>Mounted inside {@code MapLayerMid}'s panorama-sized wrapper, so
 * any positioned child here scrolls with L2 at 0.5× parallax — chimney
 * smoke stays glued to the cottage as the player drags the world.
 *
 * <p>Children position themselves with {@code top: X%; left: Y%} where
 * the percentages are relative to the panorama's natural 2172×724
 * frame. Coordinates measured by visual inspection of each
 * {@code apps/mobile/src/assets/map_mg/<biome>.png}.
 */
export function BiomeMidEffects({ biomeId }: BiomeMidEffectsProps) {
  switch (biomeId) {
    case 'kingdom':
      return <KingdomMidEffects />;
    case 'cove':
      return <CoveMidEffects />;
    default:
      return null;
  }
}
